import { ThemeColorVariable, ThemeSpaceVariable } from "@caspeco/casper-ui-library.base-ui.theme";
// eslint-disable-next-line import/no-named-as-default
import styled from "styled-components";
import { BreakPoint } from "types/ui";

export const StyledSectionTabsOuterWrapper = styled.div`
	background-color: ${ThemeColorVariable.Background};
	flex-direction: row;
	position: sticky;
	top: 0;
	user-select: none;
	width: 100%;
	z-index: 1;
`;

export const StyledSectionTabsInnerWrapper = styled.div`
	display: flex;
	height: 100%;
	justify-content: flex-start;
	overflow: hidden;
	position: relative;

	#sectiontabs-label {
		/* Not visible in view but still accessible to screen readers */
		clip: rect(0 0 0 0);
		clip-path: inset(100%);
		height: 1px;
		overflow: hidden;
		position: absolute;
		white-space: nowrap;
		width: 1px;
	}

	/** Don't display the navigate buttons on touch screens 
   * instead scroll is supported, see query style below. */
	#sectiontabs-navigateleft,
	#sectiontabs-navigateright {
		display: none;
	}

	@media not all and (pointer: coarse) {
		#sectiontabs-navigateleft,
		#sectiontabs-navigateright {
			display: initial;
			height: 100%;
			padding: 0 ${ThemeSpaceVariable.Medium};
			position: absolute;
			width: 50px;
			z-index: 1;
		}

		#sectiontabs-navigateleft {
			background: linear-gradient(to right, ${ThemeColorVariable.Background} 70%, transparent);
			left: 0;
		}

		#sectiontabs-navigateright {
			background: linear-gradient(to left, ${ThemeColorVariable.Background} 70%, transparent);
			right: 0;
		}
	}
`;

export const StyledSectionTabs = styled.nav`
	display: flex;
	overflow-x: scroll;
	padding: ${ThemeSpaceVariable.Small} ${ThemeSpaceVariable.Medium};

	@media (min-width: ${BreakPoint.Medium}) {
		padding: ${ThemeSpaceVariable.Medium};
	}

	/** Apply horizontal scroll only for touch screens.
   * (here determined through hover:none) */
	@media not all and (pointer: coarse) {
		overflow-x: hidden;
	}
`;
